import PropTypes from 'prop-types';
import { Layout } from 'antd';
import '../styles/Main.scss';
import Header from './Header';
import Sidebar from './Sidebar/Sidebar';

const { Content } = Layout;
const AdminLayout = props => {
  return (
    <>
      <Layout>
        <Sidebar />
        <Layout>
          <Header />
          <Content className="contentwraper">
            <div className="scrolldiv">{props.children}</div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminLayout;
